import { Grid, Typography } from '@mui/material';
import { useForm } from "react-hook-form";
import { ControlledInput } from '../../components/forms/input/ControlledInput';
import { ControlledTextArea } from '../../components/forms/input/ControlledTextArea';
import { endpoints } from '../../api/endpoints';
import { ModalFooter } from '../../components/modal/ModalFooter';
import AddEditModal from '../../components/modal/Modal';
import { toast } from 'react-toastify';
import * as Yup from "yup";
import { yupResolver } from '@hookform/resolvers/yup';

export default function AddEditLockerTypeModal({ open, setOpen, setSelectedItem, selectedItem, refetch }: { open: boolean, refetch: () => void, setOpen: (value: boolean) => void, selectedItem: any, setSelectedItem: (value: any) => void }) {
    return (
        <AddEditModal title={selectedItem ? 'Edit Locker Type' : 'Add New Locker Type'} setOpen={setOpen} setSelectedItem={setSelectedItem} open={open}>
            <GeneralInfo selectedItem={selectedItem} setSelectedItem={setSelectedItem} setOpen={setOpen} refetch={refetch} />
        </AddEditModal>
    );
}

const GeneralInfo = ({ setSelectedItem, selectedItem, setOpen, refetch }: { setSelectedItem: (value: any) => void, selectedItem: any, setOpen: (value: boolean) => void, refetch: () => void }) => {
    const { handleSubmit, control, formState: { errors, } } = useForm(
        {
            resolver: yupResolver(LockerTypeSchema),
            defaultValues: selectedItem ?? {
                title: '',
                length: '',
                height: '',
                breadth: '',
                rate: '',
                heldAmount: '',
                description: '',
            }
        }
    )

    const cancelMessage = 'Cancel current unsaved changes and go back to Locker Type list?'

    const onSuccess = (values: any, id?: number) => {
        if (values.id) {
            refetch()
            setOpen(false);
            setSelectedItem(null)
        } else {
            refetch()
            setOpen(false);
            setSelectedItem(null)
        }
    }

    const onError = (err: any) => {
        toast.error(err)
        setOpen(false);
        setSelectedItem(null)
    }

    const handleClose = () => {
        setOpen(false);
        setSelectedItem(null)
    };

    return (
        <>
            <Typography component={'p'} mt={2} mb={2}>General Information</Typography>
            <Grid container spacing={2}>
                <Grid item xs={12} >
                    <ControlledInput name="title" control={control} errors={errors} label="Title" />
                </Grid>
                <Grid item xs={6} >
                    <ControlledInput type='number' name="rate" control={control} errors={errors} label="Rate" />
                </Grid>
                <Grid item xs={6} >
                    <ControlledInput type='number' name="heldAmount" control={control} errors={errors} label="Held Amount" />
                </Grid>
                <Grid item xs={4} >
                    <ControlledInput type='number' name="length" control={control} errors={errors} label="Length" />
                </Grid>
                <Grid item xs={4} >
                    <ControlledInput type='number' name="height" control={control} errors={errors} label="Height" />
                </Grid>
                <Grid item xs={4} >
                    <ControlledInput type='number' name="breadth" control={control} errors={errors} label="Breadth" />
                </Grid>
                <Grid item xs={12} >
                    <ControlledTextArea name="description" control={control} errors={errors} label="Description" />
                </Grid>
            </Grid>
            <ModalFooter endpoint={endpoints.lockerType.api} onSuccess={onSuccess} handleSubmit={handleSubmit} handleModalClose={handleClose} selectedItem={selectedItem} cancelMessage={cancelMessage} onError={onError} />
        </>
    )
}

export const LockerTypeSchema = Yup.object().shape({
    rate: Yup.number().required('Rate Required').notOneOf([0], 'Rate Required').typeError('Rate Required'),
    title: Yup.string().required("Name Required"),
    length: Yup.string().required("Length Required"),
    height: Yup.string().required("Height Required"),
    breadth: Yup.string().required("Breadth Required"),
    heldAmount: Yup.string().required("Held Amount Required").typeError('Held Amount Required'),
    description: Yup.string(),
});